import request from "./request";

const api = {
    // 登录
    logon: (data: object) => {
        return request.post('/official-api/login', data)
    },
    // 详情
    detail: (data: object) => {
        return request.post('/official-api/im/detail', data)
    },
    // 激活
    activate:(data: object) => {
        return request.post('/official-api/im/activate', data)
    },
    //产品列表 
    ProductList:(data: object) => {
        return request.post('/official-api/get_products', data)
    },
    
}

export default api
